<template>
	<div>
		
		<div class="r-title">
			<img src="../../assets/imgs/news/news-title-bg.png" class="r-title-bg">
			<span style="z-index: 1;position: relative;">Topics</span>
		</div>
		
		<div>
			
			<div style="display: flex;flex-direction: column;">
				<div style="display: flex;flex-direction: column;padding: 2rem;border-radius: 1rem;margin-top: 1rem;cursor: pointer;" v-for="(item, index) in data" :key="index"
						class="hover-up transition-normal topic-box" @click="tocircletopic(item.id)">
					<div style="display: flex;align-items: center;">
						<div style="flex: 1;display: flex;align-items: center;">
							<div class="avatar" :style="{backgroundImage:'url('+item.avatar+')'}" style="min-width: 4rem;height: 4rem;margin-right: 1rem;"></div>
							<div style="display: flex;flex-direction: column;">
								<div style="font-weight: bold;font-size: 1.2rem;">{{item.title}}</div>
								<div style="display: flex;flex-wrap: wrap;">
									<span v-for="(tag, tindex) in item.tags" :style="{color:colorlist[tindex]}" style="margin-right: 0.5rem;font-size: 0.5rem;">#{{tag.name}}</span>
								</div>
							</div>
						</div>
						<div style="display: flex;align-items: center;" class="title-r">
							<img src="../../assets/imgs/dis-right-icon.png" style="width: 1rem;height: 1rem;margin-right: 0.5rem;">
							<div style="margin-right: 2rem;">{{item.followCount}}</div>
							<div style="display: flex;">
								<div :style="{backgroundImage:'url('+avatar+')'}" v-for="(avatar, avatarindex) in item.avatars.slice(0,3)" :key="avatarindex"
										style="width: 2rem;height: 2rem;border-radius: 50%;margin-left: -0.5rem;background-position: center;background-repeat: no-repeat;background-size: cover;"></div>
							</div>
						</div>
					</div>
					<div style="font-size: 1rem;color: #333;margin: 1rem 0;">
						{{item.profile}}
					</div>
					<!-- <img src="../../assets/imgs/join.png" style="width: 5rem;height: 2.2rem;"> -->
				</div>
				<div v-show="data.length==0&&!loading" class="nodata-box">
					<img src="../../assets/imgs/nodata.svg" class="nodata-img">
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	
		import axios from 'axios'
		import {baseUrl} from '../../assets/js/public.js'
		export default {
			data() {
				return {
					type:0,
					data:[],
					colorlist:['#01A587', '#8D66F8', '#ED532B', '#D8BE50', '#52A5F7'],
					loading:true
				}
			},
			components: {
			},
			methods: {
				tocircletopic(id){
					this.$router.push({name:'circletopic',query:{id:id}})
				},
				getdata(){
					this.loading = true
					this.request({
						method: 'get',
						url: '/gci/user/circle/list',
					}).then(res => {
						this.data = res.data.items
						this.loading = false
					}).catch(error => {
						console.error(error.response)
					})
				}
			},
			mounted() {
				this.type = this.$route.query.type
				this.getdata()
			}
		}
</script>

<style lang="scss" scoped>
	.r-title{
		height: 3rem;
		font-size: 1.5rem;
		font-weight: bold;
		position: relative;
		.r-title-bg{
			width: 13rem;position: absolute;left: -0.5rem;top: -2rem
		}
	}
	
	.avatar{
		background-position: center;background-repeat: no-repeat;background-size: cover;border-radius: 50%;
	}
	@media (max-width:767px) {
		.title-r{
			display: none !important;
		}
		.topic-box{
			padding: 1rem !important;
		}
	}
</style>